import { HttpClient } from './HttpClient.js';


export const GroupService = {

    
    async getGroupByProfile(profileType, distpatch) {
        return await HttpClient.get(`/group/get-groups-by-profile/${profileType}/${distpatch}`).then(response => response);
    },

    async saveGroup(formData){
        return await HttpClient.post('/group',formData).then(response => response);
    },
    
    async encriparTodos(usuarios){
        return await HttpClient.post('/notice/encript-users', usuarios).then(response => response)
    },
    
    async encriptar(form){
        return await HttpClient.get('/encriptacion/'+form).then(response => response);
    },

    async edit(idGrupo, form){
        return await HttpClient.post('/group/modify-group/'+idGrupo,form).then(response => response);
    },

    async getUsersByGroups(idGrupo){
        return await HttpClient.get('/group/get-users-by-group/'+idGrupo).then(response => response)
    },

    async deleteUserByGroup(idUser, idGrupo){
        return await HttpClient.delete(`/group/delete-remove-member/${idUser}/${idGrupo}`).then(response => response);
    },

    async getUserFree(despacho){
        return await HttpClient.get(`/group/get-free-users/${despacho}`).then(response => response);
    },

    async reasignarGroup(idGE, idGN){
        return await HttpClient.delete(`/group/delete/${idGE}/${idGN}`).then(response => response)
    },

    async addNewsUsers(forms){
        return await HttpClient.post('/group/post-add-member',forms).then(response => response);
    },

    async getSupervisor(despacho){
        return await HttpClient.get('/user/get-supervisor-type/'+despacho).then(response => response);
    },

    async getListGroups(idE, despacho){
        return await HttpClient.get('/group/get-groups-except/'+idE+'/'+despacho).then(response => response)
    }
}